import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { mdiCheck, mdiStar } from '@mdi/js';
import { TranslateService } from '@ngx-translate/core';
import * as React from 'react';

import iocTypes from '../rvirus.imap';
import { lazyInject } from '../rvirus.ioc';

import { TranslationKeyMap } from './insight.i18n';
import { PersistInsightProps } from './persist.insight.model';

class PersistInsightImpl extends React.Component<PersistInsightProps> {
    @lazyInject(iocTypes.TranslateService.identifier)
    private readonly _translateService: TranslateService;

    render(): React.ReactNode {
        return (
            (!this.props.disallowSetDefault ||
                !this.props.disallowSetFavourite) && (
                <div className="insight-persist">
                    <button
                        type="button"
                        className="btn bg-transparent pr-0 pl-0 mr-3 cmps-cdk-py-0dot5"
                        disabled={this.props.disallowSetDefault}
                        onClick={() =>
                            !this.props.onDefaultClick
                                ? null
                                : this.props.onDefaultClick(
                                      !this.props.isDefault,
                                  )
                        }
                    >
                        {this._translateService.instant(
                            TranslationKeyMap._7151_DEFAULT,
                        )}{' '}
                        {this.props.isDefault && (
                            <div className="d-inline cmps-icon insight-is-default">
                                <svg>
                                    <path d={mdiCheck}></path>
                                </svg>
                            </div>
                        )}
                    </button>
                    <button
                        type="button"
                        className="btn bg-transparent pr-0 pl-0 cmps-cdk-py-0dot5"
                        disabled={this.props.disallowSetFavourite}
                        onClick={() =>
                            !this.props.onFavouriteClick
                                ? null
                                : this.props.onFavouriteClick(
                                      !this.props.isFavourite,
                                  )
                        }
                    >
                        {this._translateService.instant(
                            TranslationKeyMap._7152_FAVOURITE,
                        )}{' '}
                        {this.props.isFavourite && (
                            <div className="d-inline cmps-icon insight-is-favourite">
                                <svg>
                                    <path d={mdiStar}></path>
                                </svg>
                            </div>
                        )}
                    </button>
                </div>
            )
        );
    }
}

export const PersistInsight = PersistInsightImpl;

@Component({
    selector: '[rvirus][cmpsInsightPersist]',
    template: ` <cmps-insight-persist
        [isDefault]="isDefault"
        [isFavourite]="isFavourite"
        [disallowSetDefault]="disallowSetDefault"
        [disallowSetFavourite]="disallowSetFavourite"
        (onDefaultClick)="defaultClick.emit($event)"
        (onFavouriteClick)="favouriteClick.emit($event)"
    ></cmps-insight-persist>`,
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.ShadowDom,
})
export class PersistInsightComponent {
    @Input() isDefault: boolean;
    @Input() isFavourite: boolean;
    @Input() disallowSetDefault: boolean;
    @Input() disallowSetFavourite: boolean;
    @Output() defaultClick: EventEmitter<boolean> = new EventEmitter();
    @Output() favouriteClick: EventEmitter<boolean> = new EventEmitter();
}
